import api from './api';

export const LIVE_IVR_WEB_ORIGIN = 'https://medeffects-distributor-demo.pages.dev';
export const LIVE_IVR_API_ORIGIN = 'https://medeffects-live-ivr-demo.onrender.com';
const loopback = (url) => ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);

export function liveIvrEnvironment({
  webOrigin = window.location.origin,
  apiBase = api.defaults?.baseURL,
  localQa = process.env.REACT_APP_LIVE_IVR_LOCAL_QA === 'true',
} = {}) {
  let web, backend;
  try {
    web = new URL(webOrigin);
  } catch {
    return { required: false, allowed: false };
  }
  const localRequested = localQa && loopback(web) && ['http:', 'https:'].includes(web.protocol);
  try {
    backend = new URL(apiBase);
  } catch {
    return { required: web.origin === LIVE_IVR_WEB_ORIGIN || localRequested, allowed: false };
  }
  const pinnedWeb = web.origin === LIVE_IVR_WEB_ORIGIN;
  const pinnedApi = backend.origin === LIVE_IVR_API_ORIGIN;

  const local =
    localRequested && loopback(backend) && ['http:', 'https:'].includes(backend.protocol);
  const cleanApi =
    !backend.username &&
    !backend.password &&
    !backend.search &&
    !backend.hash &&
    /^\/api\/?$/.test(backend.pathname);
  return {
    required: pinnedWeb || pinnedApi || localRequested,
    allowed: cleanApi && ((pinnedWeb && pinnedApi) || local),
  };
}

export const validLiveIvrCapability = (row) =>
  row?.schemaVersion === 1 &&
  row.environment === 'reviewer' &&
  row.capabilities?.insuranceVerification === 'live-pverify' &&
  row.capabilities.liveIvrSubmitRole === 'admin' &&
  row.capabilities.liveIvrConfirmationRequired === true;

export async function readLiveIvrCapability(options) {
  const response = await api.get('/reviewer/environment', options);
  const row = response?.data?.data || response?.data;
  if (!validLiveIvrCapability(row)) throw new Error('Live insurance verification is unavailable.');
  return row;
}
